import { ClientId, FeaturesByClientIds, FeaturesValues } from './constants';
import { getPersistedParameters } from './persistParameterContext';

type FeatureByClientId = `is${FeaturesValues}`;
type GetFeaturesByClientId = Record<FeatureByClientId, boolean>;

export const getFeaturesByClientId = (clientId?: ClientId): GetFeaturesByClientId => {
  if (!clientId) {
    const params = getPersistedParameters();
    clientId = params?.client_id as ClientId;
  }

  return {
    isBypassGuidedSignIn: FeaturesByClientIds.BYPASS_GUIDED_SIGN_IN.includes(clientId),
    isHideForgotPasswordLink: FeaturesByClientIds.HIDE_FORGOT_PASSWORD_LINK.includes(clientId),
    isAllowOktaSignInWithRedirect: FeaturesByClientIds.ALLOW_OKTA_SIGN_IN_WITH_REDIRECT.includes(clientId),
    isPreventAutoSignIn: FeaturesByClientIds.PREVENT_AUTO_SIGN_IN.includes(clientId),
    isAllowOnlySignIn: FeaturesByClientIds.ALLOW_ONLY_SIGN_IN.includes(clientId),
    isDisplayMGMRewardsPromoBanner: FeaturesByClientIds.DISPLAY_MGM_REWARDS_PROMO_BANNER.includes(clientId),
    isMfaEnabled: FeaturesByClientIds.MFA_ENABLED.includes(clientId),
    isPasskeyEnabled: FeaturesByClientIds.PASSKEY_ENABLED.includes(clientId),
    isIdxApiEnabled: FeaturesByClientIds.IDX_API_ENABLED.includes(clientId),
    isPostSignIn2faEnrollmentEnabled: FeaturesByClientIds.POST_SIGNIN_2FA_ENROLLMENT_ENABLED.includes(clientId),
  };
};
